import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import axios from 'axios';
import Honeybadger from '@honeybadger-io/js';

import { Spinner } from '../../../../shared/components/Spinner';
import { ERROR_GENERAL } from '../../../../shared/constants';
import { STRIPE_CONNECT_ONBOARDING } from '../../../shared/api';
import { WorkspaceLayout } from '../../../shared/components/Layout';

import layoutStyles from '../../../shared/styles/_layout.module.scss';
import componentStyles from './Onboarding.module.scss';

const Onboarding = () => {
  const location = useLocation();

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // A Stripe Connect refresh URL is the URL that a user will be redirected to if the
  // onboarding link is expired, has been previously visited, or is otherwise invalid. We
  // use the same URL and component as for regular onboarding, but append `?refresh=true`
  // so that an error message can be displayed.
  const urlParams = new URLSearchParams(location.search);
  const isRefreshUrl = urlParams.get('refresh');

  useEffect(() => {
    if (isRefreshUrl === 'true') {
      setError(ERROR_GENERAL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createOnboardingLink = async () =>
    axios
      // TODO: Investigate why JWT is not required.
      .post(STRIPE_CONNECT_ONBOARDING)
      .then((response) => response.data.url)
      .catch((error) => {
        const customError = new Error(error.message);
        Object.assign(customError, error);
        customError.customMessage = error.response?.data?.message;
        throw customError;
      });

  const handleSubmit = async (event) => {
    event.preventDefault();

    setError('');
    setLoading(true);

    try {
      const onboardingUrl = await createOnboardingLink();
      window.location.href = onboardingUrl;
    } catch (error) {
      const errorMessage = error.customMessage || ERROR_GENERAL;
      setError(errorMessage);
      setLoading(false);
      Honeybadger.notify(error);
    }
  };

  const errorAlert = <div className="alert alert-danger alert-form">{error}</div>;

  return (
    <WorkspaceLayout>
      <h1 className={layoutStyles.dashboard__title}>Onboarding.</h1>

      <div className={layoutStyles.dashboard__panel}>
        <img
          alt="Stripe logo"
          className={componentStyles['stripe-logo']}
          src="https://images.ctfassets.net/fzn2n1nzq965/HTTOloNPhisV9P4hlMPNA/cacf1bb88b9fc492dfad34378d844280/Stripe_icon_-_square.svg?q=80&w=1082"
        />

        <form onSubmit={handleSubmit}>
          <button className="btn--primary" disabled={loading} type="submit">
            Onboard
          </button>
        </form>

        {loading && <Spinner />}

        {error && errorAlert}
      </div>
    </WorkspaceLayout>
  );
};

export default Onboarding;
